import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatChipsModule} from '@angular/material/chips';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {FiltersComponent} from '@app/assetfilter/filters/filters.component';
import {SearchComponent} from '@app/assetfilter/search/search.component';
import {TagModule} from '@app/tag/tag.module';
import {FilterDialogComponent} from './filter-dialog/filter-dialog.component';
import {FilterPanelButtonComponent} from './filter-panel-button/filter-panel-button.component';
import {FilterPanelComponent} from './filter-panel/filter-panel.component';
import {FiltersSheetButtonComponent} from './filters-sheet-button/filters-sheet-button.component';

import {FiltersSheetComponent} from './filters-sheet/filters-sheet.component';

@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        TagModule,
        MatChipsModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        MatInputModule,
        MatDatepickerModule,
        MatDialogModule,
        SearchComponent,
        FiltersComponent,
        FiltersSheetComponent,
        FiltersSheetButtonComponent,
        FilterPanelComponent,
        FilterPanelButtonComponent,
        FilterDialogComponent,
    ],
    exports: [
        SearchComponent,
        FiltersComponent,
        FiltersSheetButtonComponent,
        FilterPanelButtonComponent,
    ],
})
export class AssetfilterModule {}
